import { bypassAgenticStreamProxyInDev, agenticStreamRequestHeaders } from './agenticStreamHttp';
import type { BrowserStreamReport } from '../../../../src/shared/agenticStreamTelemetry';

/** Reuse the token already obtained for the stream; no refresh or wait during page teardown. */
export function createStreamTelemetryReporter() {
  let token: string | null = null;
  return {
    setToken(value: string) { token = value; },
    report(report: BrowserStreamReport) {
      if (!token) return;
      try {
        void fetch(bypassAgenticStreamProxyInDev('/api/chat-stream-telemetry'), {
          method: 'POST', credentials: 'include', keepalive: true,
          headers: agenticStreamRequestHeaders(),
          body: JSON.stringify({ idToken: token, report }),
        }).catch(() => {});
      } catch { /* Telemetry may be lost during offline/page teardown. */ }
    },
  };
}
